import {FACTIONS} from "../../../constants/factions";

export const BEASTMEN_QUOTES = [{
  quote: 'Трусливые куски мяса!',
  author: 'Гарм Фольквир, верховный герольд Рогатой стаи зверолюдов',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Мы не берём дань. Дань — это когда остаются живые. У нас не остаётся',
  author: 'Карк Молосс, зверолюд-трибун Приплодных казарм',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Ваши империи — лишь растущие куски мяса, которые мы проглотим',
  author: 'Орра Скалль, зверолюд-квестор Когтей',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Голод не знает жалости. Я — голод',
  author: 'Рагн Висс, претор Красного логова зверолюдов',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Город — это просто большая куча еды, собранная в одном месте',
  author: 'Бьярки Хродгар, зверолюд-децемвир Свалок',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Мясо не спрашивает, кто его ел. Мясо просто становится силой',
  author: 'Хаген Вельф, зверолюд-предводитель Походных Станов',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Вы должны понять — им не нужен наш город. Голод зверолюдов сотрет его с лица земли',
  author: 'Зафир Тальский, прокуратор вольного города Таль, в попытке вдохновить ополчение',
  factionId: FACTIONS.BEASTMEN
}, {
  quote: 'Когда-то я был прокуратором. У того города больше нет прокуратора. Нет города',
  author: 'Из мемуаров Зафира Тальского об обороне вольного города Таль от Черной орды',
  factionId: FACTIONS.BEASTMEN
}]